import React, { forwardRef, Fragment, useEffect, useState } from "react";
import InfoDialog from "./InfoDialog";
import {
  Button,
  Dialog,
  DialogContent,
  Slide,
} from "@mui/material";
import { CheckIcon, CrossIcon } from "../../assets";
import { isValidEmail } from "../../helpers/common";
import { signUpService } from "../../services/Auth";

const Transition = forwardRef(function Transition(props, ref) {
  return <Slide direction="up" ref={ref} {...props} />;
});

const initialEBook = {
  name: "",
  email: "",
};
const initialError = {
  name: "",
  email: "",
  submit: "",
};

const Getebook = ({ open, setOpen }) => {
  const [eBookData, setEBookData] = useState(initialEBook);
  const [error, setError] = useState(initialError);
  const [loading, setLoading] = useState(false);
  const [infoOpen, setInfoOpen] = useState(false);

  useEffect(() => {
    if (!open) {
      setEBookData(initialEBook);
      setError(initialError);
    }
  }, [open]);

  const handleError = (data, field) => {
    const errors = { submit: "" };

    // Validate Name (if the field is being changed or on submit)
    if (!field || field === "name") {
      if (!data.name) {
        errors.name = "Name is required";
      } else {
        errors.name = "";
      }
    }

    // Validate Email (if the field is being changed or on submit)
    if (!field || field === "email") {
      if (!data.email) {
        errors.email = "Email is required";
      } else if (!isValidEmail(data.email)) {
        errors.email = "Please enter a valid email address";
      } else {
        errors.email = "";
      }
    }

    setError((prevErrors) => ({
      ...prevErrors,
      ...errors,
    }));

    // Return true if there are no errors
    return Object.keys(errors).every((key) => !errors[key]);
  };

  const getebook = async () => {
    if (handleError(eBookData)) {
      try {
        setLoading(true);
        const resp = await signUpService({
          FirstName: eBookData.name,
          Email: eBookData.email,
        });
        if (resp.data && resp.data.result) {
          setInfoOpen(true);
          setEBookData({ name: "", email: "" });
          handleClose();
        }
        setLoading(false);
      } catch (error) {
        setLoading(false);
        setError((prev) => ({ ...prev, submit: error.response.data.title }));
      }
    }
  };
  const handleClose = () => setOpen(false);

  const handleFieldChange = (fieldName, value) => {
    const newValues = { ...eBookData, [fieldName]: value };
    setEBookData(newValues);
    handleError(newValues, fieldName);
  };
  return (
    <Fragment>
      {infoOpen && (
        <InfoDialog
          open={infoOpen}
          setOpen={() => setInfoOpen(false)}
          infoDetail={{
            heading:
              "We've just sent you an email. Please check your inbox as well as your spam folders.",
            innerContent: "",
          }}
          handleSubmit={() => {}}
          icon={CheckIcon}
        />
      )}
      <Dialog
        open={open}
        TransitionComponent={Transition}
        keepMounted
        onClose={handleClose}
        fullWidth
        PaperProps={{
          style: {
            maxWidth: "700px",
            width: "100%",
            borderRadius: "24px",
            backgroundColor: "#262626",
            border: "1px solid rgba(255, 255, 255, 0.16)",
          },
        }}
      >
        <DialogContent className="!p-5 relative">
          <img
            src={CrossIcon}
            alt="crossIcon"
            className="ml-auto cursor-pointer absolute top-5 right-5"
            onClick={handleClose}
          />

          <div className="flex flex-col gap-8 items-center mt-[48px] mb-16 w-full max-w-[320px] mx-auto">
            <p className="text-[32px] leading-10 font-bold text-white">
              Get eBook
            </p>
            <div className="flex flex-col gap-6">
              <div className="flex flex-col items-start gap-2">
                <label className="text-white text-lg font-medium leading-7">
                  Name
                </label>
                <input
                  className="placeholder:normal-case h-12 rounded-lg border border-[rgba(255,255,255,0.12)] bg-[#262626] px-4 py-3 text-base text-[rgba(255,255,255,0.6)] font-normal leading-6"
                  name="name"
                  placeholder="your name"
                  value={eBookData.name}
                  type="text"
                  onChange={(event) =>
                    handleFieldChange("name", event?.target?.value)
                  }
                />
                {error.name && (
                  <span className="text-[13px] leading-5 -tracking-[0.13px] font-normal text-[#FF352A]">
                    {error.name}
                  </span>
                )}
              </div>

              <div className="flex flex-col items-start gap-2">
                <label className="text-white text-lg font-medium leading-7">
                  Email
                </label>
                <input
                  className="placeholder:normal-case h-12 rounded-lg border border-[rgba(255,255,255,0.12)] bg-[#262626] px-4 py-3 text-base text-[rgba(255,255,255,0.6)] font-normal leading-6"
                  name="email"
                  placeholder="your email"
                  value={eBookData.email}
                  type="email"
                  onChange={(event) =>
                    handleFieldChange("email", event?.target?.value)
                  }
                />
                {error.email && (
                  <span className="text-[13px] leading-5 -tracking-[0.13px] font-normal text-[#FF352A]">
                    {error.email}
                  </span>
                )}
              </div>

              {error.submit && (
                <div className="max-w=[250px] capitalize w-full text-sm font-medium text-[#FF352A] mt-[15px] mb-3">
                  {error.submit}
                </div>
              )}
              <Button
                variant="contained"
                type="submit"
                className="!normal-case normal-case!h-12 !py-3 !px-4 !w-full !bg-[rgba(179,7,7,1)] !border-[1px] !border-solid !border-[rgba(248,21,21,1)] !rounded-lg !text-base text-white !font-bold !leading-6 disabled:opacity-30"
                onClick={getebook}
                disabled={loading}
              >
                {loading ? "Getting eBook..." : "Get eBook"}
              </Button>
            </div>
          </div>
        </DialogContent>
      </Dialog>
    </Fragment>
  );
};

export default Getebook;
